import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-next-gray-md mb-3 md:flex md:min-w-1000 items-start p-3 gap-3" }
const _hoisted_2 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_3 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_4 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_5 = { class: "px-2 border border-next-neu rounded text-center text-xs" }
const _hoisted_6 = { class: "basis-1/3 flex flex-col justify-between" }
const _hoisted_7 = { class: "basis flex flex-col self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-bold" }, "Denominazione", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.denominazione), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-bold" }, "Settore commerciale", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.c.settori_join), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "font-bold" }, "Stato", -1)),
      _createElementVNode("div", {
        class: "min-w-285 grid gap-1 mt-1",
        style: _normalizeStyle({
                    'grid-template-columns': `repeat(${_ctx.businessUnits.length}, minmax(0, 1fr))`,
                })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "",
            key: bu.id
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(bu.label), 1),
            _createElementVNode("div", {
              class: _normalizeClass([`bg-next-${_ctx.getColoriStati(_ctx.c.stati[bu.id])}`, "px-2 border rounded text-center text-xs text-white"])
            }, _toDisplayString(_ctx.getLabel(_ctx.c.stati[bu.id])), 3)
          ]))
        }), 128))
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-bold" }, "Ultimo contatto", -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$filters.toDateTime(_ctx.c.ultimo_contatto)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        component: "router-link",
        to: { name: 'DettaglioAzienda', params: { id: _ctx.c.id } },
        class: "sm:block py-1 px-3"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Vedi ")
        ])),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}